import './Modal.scss';

import React from 'react';

import { Loading } from '../loading/Loading';

interface IModalProps {
  show: boolean;
  title: string;
  bodyText: string;
  onConfirm: () => void;
  onClose?: () => void;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  showConfirm?: boolean;
  containerClassName?: string;
}

export const Modal: React.FunctionComponent<IModalProps> = ({
  show,
  title,
  bodyText,
  onConfirm,
  onClose = () => {},
  confirmText = 'Confirm',
  cancelText = 'Close',
  isLoading = false,
  showConfirm = true,
  containerClassName = '',
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className={`modal ${containerClassName || ''}`}>
      <div className="modal-content">
        {
          isLoading
            ? <Loading />
            : <>
              <div  className="modal-header">
                <h4 className="modal-title">{title}</h4>
                <span className="modal-close" onClick={() => onClose()}>x</span>
              </div>
              <div className="modal-body">
                {bodyText}
              </div>
              <div  className="modal-footer">
                <hr />
                <div className="actions">
                  <button className="button close-btn" onClick={() => onClose()}>{cancelText}</button>
                  {showConfirm && <button className="button confirm-btn" onClick={() => onConfirm()}>{confirmText}</button>}
                </div>
              </div>
            </>
        }
      </div>
    </div>
  );
};
